import style from './modal.module.scss'

const Modal = ({active, setActive, children, width, height, padding}) => {
    const config = {
        width: width || '50%',
        height: height || '50%',
        padding: padding || '0'
    }

    if (active === true)
    return (
        <div
            className={style.wrapper}
            onClick={() => setActive(false)}
        >
            <div
                className={style.modal}
                style={config}
                onClick={(e) => e.stopPropagation()}
            >
                {children}
            </div>
        </div>
    )
}

export default Modal